<template>
  <page-outline :title="titleLabel"
    iconFA="users">

    <template slot="pageContent">
      <b-row>
        <b-col sm="6" class="form-group">
          <form-write-group-label-input v-model="labelTeam" isMandatory
            :inputLabel="$t('businessMembers.team_name')" :placeholderValue="$t('businessMembers.team_name')">
          </form-write-group-label-input>
        </b-col>
      </b-row>
      <b-row>
        <label class="col-4 col-sm-2 col-form-label">{{ $t('common.email_notification') }}</label>
        <div class="col-8 col-sm-10">
          <div class="form-group">
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" class="custom-control-input" id="radioemail1" name="radioEmail"
                value="NO" :title="$t('administration.no')" :checked="isEmailContact === 'NO'"
                @change="isEmailContact = $event.target.value" :disabled="!isEditable">
              </input>
              <label class="custom-control-label" for="radioemail1">{{ $t('common.no_label') }}</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input type="radio" class="custom-control-input" id="radioemail2" name="radioEmail"
                value="YES" :title="$t('common.yes_label')" :checked="isEmailContact === 'YES'"
                @change="isEmailContact = $event.target.value" :disabled="!isEditable">
              </input>
              <label class="custom-control-label" for="radioemail2">{{ $t('common.yes_label') }}</label>
            </div>
          </div>
        </div>
      </b-row>
      <div v-if="isEmailContact === 'YES'" class="form-group row">
        <div class="col-4 col-sm-2 col-form-label">{{ $t('common.eml_adrs') }}</div>
        <div class="col-8 col-sm-10">
          <input class="form-control" type="text" :placeholder="emailaddressLabel"
            v-model="emailNotification" :disabled="!isEditable">
          </input>
        </div>
      </div>
      <div v-if="isEmailContact === 'YES'" class="form-group row">
        <div class="col-4 col-sm-2 col-form-label">{{ $t('common.min_amount') }}</div>
        <div class="col-8 col-sm-10">
          <input class="form-control" type="text" :placeholder="amountLabel"
            v-model="amountNotification" :disabled="!isEditable">
          </input>
        </div>
      </div>

      <hr/>
      <div v-if="hasGroups" class="row headerGroupList showLargeScreenOnly">
        <label class="col-md-1 col-form-label">{{ $t('businessMembers .group_layer') }}</label>
        <label class="col-md-2 col-form-label text-left">{{ $t('businessMembers.grp_nm') }}</label>
        <label class="col-md-1 col-form-label"></label>
        <label class="col-md-2 col-form-label text-left">{{ $t('businessMembers.mmbr') }}</label>
        <label class="col-md-1 col-form-label"></label>
        <label style="padding-left: 22px" class="col-md-1 col-form-label">{{ $t('businessMembers.vsblty') }}</label>
        <label class="col-md-2 col-form-label">{{ $t('common.rm_label') }}</label>
        <label class="col-md-2 col-form-label">{{ $t('businessMembers.grp_actns') }}</label>
      </div>

      <div v-if="!isSmartphone" v-for="(group, index) in sortedArray" :key="index">
        <!-- TLV - ERI 21/02/2020
          La modification de niveaux de groupes n'est autorisée que s'il y a plusieurs groupes
        -->
        <b-row class="groupDiv showLargeScreenOnly">
          <b-col cols="1" class="arrow-box">
            <b-row>
              <i v-if="index === 0" class="icon icon-arrow-disabled icon-arrow-sort icon-arrow-sort-up fa fa-caret-up"></i>
              <a v-else href="#" @click="upGroupLevel(group.label)">
                <i class="icon icon-arrow-sort icon-arrow-sort-up fa fa-caret-up" :class="canEditGroupOrderStyle"></i>
              </a>
            </b-row>
            <label class="lvl-group row">{{ index + 1 }}</label>
            <b-row>
              <a v-if="index < sortedArray.length - 1" href="#" @click="lowerGroupLevel(group.label)">
                <i class="icon icon-arrow-sort icon-arrow-sort-down fa fa-caret-down" :class="canEditGroupOrderStyle"></i>
              </a>
              <i v-else class="icon icon-arrow-sort icon-arrow-sort-down fa fa-caret-down icon-arrow-disabled"></i>
            </b-row>
          </b-col>
          <div class="row col-md-11 groupDivContainers">
            <b-col md="2" class="leftGroupDiv">
              <label class="col-form-label label-group longword-word"><b>{{ group.label }}</b></label>
            </b-col>
            <b-col md="8" class="rightGroupDiv">
              <b-row v-for="(member, index) in group.members" :key="index">
                <label class="col-7 col-md-7 longword-word">{{member.identifier}}</label>
                <swatches class="col-2 col-md-2"
                  :trigger-style="{ width: '20px', height: '20px' }"
                  v-model="membersColor[member.index]"
                  :colors="colors" row-length="5" shapes="squares"
                  popover-to="right" swatch-size="20"
                  @open="setCurrentMemberModifyVisibility(group.label,index)"
                  @close="setMemberVisibility($event)" :disabled="!canChangeVisibility">
                </swatches>
                <a class="col-1 col-md-1" @click="removeMemberFromGroup(group.label, member.identifier)" href="#">
                  <i class="icon icon-delete-member fa fa-times" :style="canRemoveMemberFromGroupStyle"></i>
                </a>
                <div class="col-1 col-md-1"/>
              </b-row>
            </b-col>
            <b-col md="2" class="actionGroupDiv">
              <b-row>
                <a @click="setCurrentGroupNumber(group.label)"
                  href="/accountMembers/addMemberGroupMembersList/"
                  class="button-action button-add-mbr button-delete-group"
                  :disabled="!canAddMemberToGroup">
                  <f7-icon f7="add" class="smallIcons"></f7-icon>
                  {{ $t('businessMembers.add_member_small') }}
                </a>
              </b-row>
              <b-row>
                <button round type="button" class="button-action button-delete-group button-add-mbr"
                  @click="deleteGroup(group.label)" :disabled="!canDeleteGroup">
                  <f7-icon f7="trash" class="smallIcons"></f7-icon>
                  {{ $t('businessMembers.rm_group') }}
                </button>
              </b-row>
            </b-col>
          </div>
        </b-row>
        <b-row class="showSmallScreenOnly">
          <b-col cols="1" class="arrow-box">
            <a class="row" @click="upGroupLevel(group.label)" href="#" :disabled="!canEditGroupOrder">
              <i v-if="index === 0" class="icon icon-arrow-disabled icon-arrow-sort icon-arrow-sort-up fa fa-caret-up"></i>
              <i v-else class="icon icon-arrow-sort icon-arrow-sort-up fa fa-caret-up" :class="canEditGroupOrderStyle"></i>
            </a>
            <label class="lvl-group row">{{ index + 1 }}</label>
            <a class="row" @click="lowerGroupLevel(group.label)" href="#" :disabled="!canEditGroupOrder">
              <i v-if="index < sortedArray.length - 1" class="icon icon-arrow-sort icon-arrow-sort-down fa fa-caret-down" :class="canEditGroupOrderStyle"></i>
              <i v-else class="icon icon-arrow-sort icon-arrow-sort-down fa fa-caret-down icon-arrow-disabled"></i>
            </a>
          </b-col>
          <b-col cols="10" class="card">
            <div class="card-header">
              <label class="col-form-label label-group longword-word"><b>{{group.label}}</b></label>
            </div>
            <div class="row mobile-card-body" v-for="(member, index) in group.members" :key="index">
              <label class="col-7 col-md-7 longword-word emailsize">{{member.identifier}}</label>
              <swatches class="col-2 col-md-2"
                :trigger-style="{ width: '20px', height: '20px' }"
                v-model="membersColor[member.index]" :colors="colors"
                row-length="5" shapes="squares" popover-to="right"
                swatch-size="20" @open="setCurrentMemberModifyVisibility(group.label,index)"
                @close="setMemberVisibility($event)">
              </swatches>
              <a class="col-1 col-md-1" @click="removeMemberFromGroup(group.label, member.identifier)" href="#">
                <i class="icon icon-delete-member fa fa-times" :style="canRemoveMemberFromGroupStyle"></i>
              </a>
              <div class="col-1 col-md-1"/>
            </div>
            <div class="card-footer">
              <a href="/accountMembers/addMemberGroupMembersList/"
                class="button-action button-delete-group btn-mobile-footer"
                @click="setCurrentGroupNumber(group.label)" :disabled="canAddMemberToGroup">
                <f7-icon f7="add" class="smallIcons"></f7-icon>
                {{ $t('businessMembers.add_member_small') }}
              </a>
              <button round type="button" class="button-action button-delete-group btn-mobile-footer"
                @click="deleteGroup(group.label)" :disabled="!canDeleteGroup">
                <f7-icon f7="trash" class="smallIcons"></f7-icon>
                {{ $t('businessMembers.rm_group') }}
              </button>
            </div>
          </b-col>
        </b-row>
      </div>
      <b-row class="groupDiv justify-content-end">
        <f7-button round
          class="attachmentButton buttonAccordionForm longword-word milkyBlockBlack"
          style="margin-bottom: 1rem;" @click="addNewGroup" :disabled="!canAddNewGroup">
          {{ $t('businessMembers.add_group') }}
        </f7-button>
      </b-row>
    </template>

    <template slot="footerButtons">
      <b-row class="justify-content-start" v-if="isInViewMode === true">
        <b-col md="10" offset-md="1">
          <b-row>
            <b-col cols="6" md="3" offset-md="9" class="height-button">
              <f7-button
                class="button-action milkyBlockBlack"
                @click="addTeam">
                <f7-icon fa="save"></f7-icon>
                <span>{{ $t('common.sve') }}</span>
              </f7-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="justify-content-start" v-else>
        <b-col md="10" offset-md="1">
          <b-row>
            <b-col md="3" offset-md="6">
              <f7-button
                class="button-action milkyBlockBlack"
                @click="deleteTeam()"
                :disabled="!isDeletable">
                <f7-icon fa="trash"></f7-icon>
                <span>{{ $t('businessMembers.dlt_tm') }}</span>
              </f7-button>
            </b-col>
            <b-col md="3">
              <f7-button
                class="button-action milkyBlockBlack"
                @click="editTeam()"
                :disabled="!isEditable">
                <f7-icon fa="save"></f7-icon>
                <span>{{ $t('common.valid_chgs') }}</span>
              </f7-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </page-outline>
</template>

<script>
import _ from 'lodash'
import Swatches from 'vue-swatches'
// import 'vue-swatches/dist/vue-swatches.min.css'

import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'AddContactGroup',
  components: {
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'swatches': Swatches
  },
  data () {
    return {
      isInViewMode: false,
      isEditable: false,
      isDeletable: false,
      isSmartphone: false,
      canEditGroupOrder: false,
      canEditGroupOrderStyle: '',
      canChangeVisibility: false,
      canRemoveMemberFromGroup: false,
      canAddMemberToGroup: false,
      canRemoveMemberFromGroupStyle: '',
      canAddNewGroup: false,
      canDeleteGroup: false,
      team: {},
      labelTeam: '',
      groups: [],
      currentSelectedGroup: 0,
      currentSelectedMember: 0,
      jsonStart: '',
      isEmailContact: '',
      emailNotification: '',
      amountNotification: '',
      membersColor: [],
      colors: ['#2196F3', '#F44336', '#8BC34A', '#E91E63', '#9C27B0', '#FF9800', '#FFEB3B', '#009688'],
      id: 0
    }
  },
  computed: {
    sortedArray: function () {
      function compare (a, b) {
        if (a.level > b.level) {
          return -1
        }
        if (a.level < b.level) {
          return 1
        }
        return 0
      }
      return this.groups.sort(compare)
    },
    hasGroups () {
      if (this.sortedArray.length > 0) {
        return true
      }
      return false
    },
    emailaddressLabel () {
      return this.$t('common.eml_adrs')
    },
    amountLabel () {
      return this.$t('common.amnt') + ' ' + this.$t('common.current_currency')
    },
    titleLabel () {
      if (!this.isInViewMode) {
        return this.$t('businessMembers.add_team')
      } else {
        return this.$t('common.team_label') + ' : ' + this.labelTeam
      }
    }
  },
  created () {
    let that = this
    if (that.$engine.firstOn().services.directPayments.filter.smartphoneStorage) {
      that.isSmartphone = true
    }

    this.$bus.$on('refresh-add-member-group-member-selected', (data) => {
      that.selectedMembers = data
      that.addMembersToGroup()
    })
    this.isEmailContact = 'NO'
  },
  mounted () {
    this.isEditable = this.$engine.firstOn().rights.rightIs('teams_add', true)
    this.isDeletable = this.$engine.firstOn().rights.rightIs('teams_delete', true)
    this.canEditGroupOrder = this.$engine.firstOn().rights.rightIs('teams_edit_groupe_order', true)
    this.canEditGroupOrderStyle = this.canEditGroupOrder ? '' : 'icon-arrow-disabled'
    this.canChangeVisibility = this.$engine.firstOn().rights.rightIs('teams_edit_member_visibility', true)
    this.canAddMemberToGroup = this.$engine.firstOn().rights.rightIs('teams_edit_add_membre', true)
    this.canRemoveMemberFromGroup = this.$engine.firstOn().rights.rightIs('teams_edit_delete_membre', true)
    this.canRemoveMemberFromGroupStyle = this.canRemoveMemberFromGroup ? '' : 'color:grey;opacity:50%'
    this.canAddNewGroup = this.$engine.firstOn().rights.rightIs('teams_edit_add_groupe', true)
    this.canDeleteGroup = this.$engine.firstOn().rights.rightIs('teams_edit_delete_groupe', true)

    if (this.$settings.currentMemberGroup.groups !== undefined) {
      this.jsonStart = _.cloneDeep(this.$settings.currentMemberGroup)
      this.groups = _.cloneDeep(this.$settings.currentMemberGroup.groups)

      this.labelTeam = this.$settings.currentMemberGroup.name

      if (this.$settings.currentMemberGroup.email_notification !== '' && this.$settings.currentMemberGroup.email_notification !== undefined) {
        this.isEmailContact = 'YES'
        this.emailNotification = this.$settings.currentMemberGroup.email_notification
        this.amountNotification = this.$settings.currentMemberGroup.amount_notification
      }

      this.isInViewMode = true
      this.isEditable = this.$engine.firstOn().rights.rightIs('teams_edit', true)

      // Setting members color:
      for (var i = 0; i < this.groups.length; i++) {
        for (var j = 0; j < this.groups[i].members.length; j++) {
          this.membersColor.push(this.setColorAccordingToVisibility(this.groups[i].members[j].visibility))
          this.groups[i].members[j].index = this.id
          this.id++
        }
      }
    }
  },
  beforeDestroy () {

  },
  methods: {
    setCurrentGroupNumber (name) {
      for (var i = 0; i < this.groups.length; i++) {
        if (name === this.groups[i].label) {
          this.currentSelectedGroup = i
        }
      }
    },
    setCurrentMemberModifyVisibility (groupLabel, memberId) {
      this.setCurrentGroupNumber(groupLabel)
      this.currentSelectedMember = memberId
    },
    setMemberVisibility ($event) {
      switch ($event) {
        case '#2196F3':
          this.groups[this.currentSelectedGroup].members[this.currentSelectedMember].visibility = 0
          break
        case '#F44336':
          this.groups[this.currentSelectedGroup].members[this.currentSelectedMember].visibility = 1
          break
        case '#8BC34A':
          this.groups[this.currentSelectedGroup].members[this.currentSelectedMember].visibility = 2
          break
        case '#E91E63':
          this.groups[this.currentSelectedGroup].members[this.currentSelectedMember].visibility = 3
          break
        case '#9C27B0':
          this.groups[this.currentSelectedGroup].members[this.currentSelectedMember].visibility = 4
          break
        case '#FF9800':
          this.groups[this.currentSelectedGroup].members[this.currentSelectedMember].visibility = 5
          break
        case '#FFEB3B':
          this.groups[this.currentSelectedGroup].members[this.currentSelectedMember].visibility = 6
          break
        case '#009688':
          this.groups[this.currentSelectedGroup].members[this.currentSelectedMember].visibility = 7
          break
        default:
          this.groups[this.currentSelectedGroup].members[this.currentSelectedMember].visibility = 0
      }
    },
    setColorAccordingToVisibility (visibility) {
      switch (visibility) {
        case '0':
          return '#2196F3'
        case '1':
          return '#F44336'
        case '2':
          return '#8BC34A'
        case '3':
          return '#E91E63'
        case '4':
          return '#9C27B0'
        case '5':
          return '#FF9800'
        case '6':
          return '#FFEB3B'
        case '7':
          return '#009688'
        default:
          return '#2196F3'
      }
    },
    lowerGroupLevel (groupLabel) {
      if (!this.canEditGroupOrder) {
        return
      }
      this.setCurrentGroupNumber(groupLabel)
      if (this.groups[this.currentSelectedGroup].level > 1) {
        var tmp = parseInt(this.groups[this.currentSelectedGroup].level) - 1
        this.groups[this.currentSelectedGroup].level = tmp.toString()
      }
      this.updateGroupsLevel(this.groups[this.currentSelectedGroup], 'down')
    },
    upGroupLevel (groupLabel) {
      if (!this.canEditGroupOrder) {
        return
      }
      this.setCurrentGroupNumber(groupLabel)
      if (this.groups[this.currentSelectedGroup].level < this.groups.length) {
        var tmp = parseInt(this.groups[this.currentSelectedGroup].level) + 1
        this.groups[this.currentSelectedGroup].level = tmp.toString()
      }
      this.updateGroupsLevel(this.groups[this.currentSelectedGroup], 'up')
    },
    updateGroupsLevel (updatedGroup, direction) {
      var tmp
      for (var i = 0; i < this.groups.length; i++) {
        if (this.groups[i] !== updatedGroup && this.groups[i].level.toString() === updatedGroup.level.toString()) {
          if (direction === 'up') {
            tmp = parseInt(this.groups[i].level) - 1
            this.groups[i].level = tmp.toString()
            this.groups.sort((a, b) => a.level < b.level)
          } else if (direction === 'down') {
            tmp = parseInt(this.groups[i].level) + 1
            this.groups[i].level = tmp.toString()
            this.groups.sort((a, b) => a.level < b.level)
          }
        }
      }
    },
    addNewGroup () {
      let that = this
      this.$f7.modal({
        title: that.$t('businessMembers.please_group_name'),
        // text: 'Enter a name of draft',
        afterText: '<div class="item-input"><input class="inputnamegroup" type="text"></div>',
        buttons: [
          {
            text: that.$t('common.cncl'),
            color: 'red',
            onClick: function () {}
          },
          {
            text: that.$t('common.create_label'),
            onClick: function () {
              var alreadyExist = false
              var isEmpty = false
              var lab = that.Dom7('.inputnamegroup').val()

              if (lab === '' || lab === undefined) {
                that.$f7.alert(that.$t('errors.empty_group_name'), that.$t('errors.error_label'), function () {
                  that.addNewGroup()
                  that.$f7.closeModal()
                })
                isEmpty = true
              }

              for (var i = 0; i < that.groups.length; i++) {
                if (that.groups[i].label === lab) {
                  that.$f7.alert(that.$t('errors.group_name_already_exists'), that.$t('errors.error_label'), function () {
                    that.addNewGroup()
                    that.$f7.closeModal()
                  })
                  alreadyExist = true
                }
              }

              if (!alreadyExist && !isEmpty) {
                that.groups.push({
                  label: that.Dom7('.inputnamegroup').val(),
                  members: []
                })
                for (let i = 0; i < that.groups.length; i++) {
                  that.groups[i].level = that.groups.length - i
                }
              } else {
                that.addNewGroup()
              }
            }
          }
        ]
      })
    },
    addMembersToGroup () {
      for (var i = 0; i < this.selectedMembers.length; i++) {
        this.groups[this.currentSelectedGroup].members.push({
          id_user_account: this.selectedMembers[i].id,
          identifier: this.selectedMembers[i].login,
          visibility: 0,
          index: this.id
        })
        this.membersColor.push(this.setColorAccordingToVisibility('0'))
        this.id++
      }
    },
    removeMemberFromGroup (label, identifier) {
      if (!this.canRemoveMemberFromGroup) {
        return
      }
      let that = this
      this.$f7.modal({
        title: that.$t('businessMembers.account_member_deletion_confirmation'),
        buttons: [
          {
            text: that.$t('common.cncl'),
            color: 'red',
            onClick: function () {
            }
          },
          {
            text: that.$t('common.yes_label'),
            onClick: function () {
              var idMemberInList = -1
              var idGroupInList = -1
              for (var i = 0; i < that.groups.length; i++) {
                if (that.groups[i].label === label) {
                  for (var j = 0; j < that.groups[i].members.length; j++) {
                    if (that.groups[i].members[j].identifier === identifier) {
                      idMemberInList = j
                      idGroupInList = i
                      break
                    }
                  }
                  break
                }
              }
              that.groups[idGroupInList].members.splice(idMemberInList, 1)
            }
          }
        ]
      })
    },
    deleteGroup (label) {
      let that = this
      this.$f7.modal({
        title: that.$t('businessMembers.want_to_delete_group'),
        buttons: [
          {
            text: that.$t('common.cncl'),
            color: 'red',
            onClick: function () {
            }
          },
          {
            text: that.$t('common.yes_label'),
            onClick: function () {
              var idGroupInList = -1
              idGroupInList = that.groups.map(elem => elem.label).indexOf(label)
              that.groups.splice(idGroupInList, 1)
              for (let i = 0; i < that.groups.length; i++) {
                that.groups[i].level = that.groups.length - i
              }
            }
          }
        ]
      })
    },
    addTeam () {
      let that = this
      if (this.isEmailContact === 'NO') {
        that.emailNotification = ''
        that.amountNotification = '0'
      }

      var json = {
        name: that.labelTeam,
        email_notification: that.emailNotification,
        amount_notification: that.amountNotification,
        groups: that.groups
      }

      if (this.checkTeamValues(json)) {
        this.$engine.firstOn().accounts
        .createMemberGroup(json)
        .then(() => {
          that.$f7.alert(that.$t('success.team_added'), that.$t('success.success_label'), function () {
            that.$f7.closeModal()
            that.$bus.$emit('refresh-cache-account-members')
            loadPage(that, {url: '/accountMembers/'})
          })
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
      }
    },
    deleteTeam () {
      let that = this
      this.$f7.modal({
        title: that.$t('businessMembers.want_to_delete_team'),
        buttons: [
          {
            text: that.$t('common.cncl'),
            color: 'red',
            onClick: function () {
            }
          },
          {
            text: that.$t('common.yes_label'),
            onClick: function () {
              that.$engine.firstOn().accounts
              .deleteGroup(that.jsonStart.id_team)
              .then(() => {
                that.$f7.alert('Team deleted', that.$t('success.success_label'), function () {
                  that.$f7.closeModal()
                  that.$bus.$emit('refresh-cache-account-members')
                  loadPage(that, {url: '/accountMembers/'})
                })
              })
              .catch(err => {
                errorMessageAlert(err, that)
              })
            }
          }
        ]
      })
    },
    checkTeamValues (json) {
      let that = this
      var oneGroupIsEmpty = false
      var oneGroupLevelZero = false
      var oneMemberInMultipleGroup = false
      var notificationError = false
      var noGroupError = false
      var memberAlreadyInGroup = []
      var isTeamNameEmpty = false

      if (json.name === '' || json.name === undefined) {
        that.$f7.alert(that.$t('errors.must_provide_name'), that.$t('errors.error_label'), function () {
          that.$f7.closeModal()
        })
        isTeamNameEmpty = true
      }

      if (json.groups.length <= 0) {
        that.$f7.alert(that.$t('errors.must_be_one_group_on_team'), that.$t('errors.error_label'), function () {
          that.$f7.closeModal()
        })
        noGroupError = true
      }
      if (this.isEmailContact === 'YES') {
        if (json.email_notification === '' || json.email_notification === undefined) {
          that.$f7.alert(that.$t('errors.must_provide_email_for_notification'), that.$t('errors.error_label'), function () {
            that.$f7.closeModal()
          })
          notificationError = true
        } else if (json.amount_notification === '' || json.amount_notification === undefined) {
          that.$f7.alert(that.$t('errors.must_provide_minimum_amount_for_notification'), that.$t('errors.error_label'), function () {
            that.$f7.closeModal()
          })
          notificationError = true
        } else if (json.amount_notification <= 0) {
          that.$f7.alert(that.$t('errors.must_be_superior_to_zero'), that.$t('errors.error_label'), function () {
            that.$f7.closeModal()
          })
          notificationError = true
        }
      }
      for (var i = 0; i < json.groups.length; i++) {
        if (json.groups[i].members.length <= 0) {
          that.$f7.alert(that.$t('errors.group_no_member'), that.$t('errors.error_label'), function () {
            that.$f7.closeModal()
          })
          oneGroupIsEmpty = true
          break
        } else if (json.groups[i].level <= 0) {
          that.$f7.alert(that.$t('errors.lvl_too_low'), that.$t('errors.error_label'), function () {
            that.$f7.closeModal()
          })
          oneGroupLevelZero = true
          break
        } else {
          var temp
          for (var j = 0; j < json.groups[i].members.length; j++) {
            temp = []
            if (memberAlreadyInGroup.length <= 0) {
              temp.push(json.groups[i].members[j])
            } else {
              for (var k = 0; k < memberAlreadyInGroup.length; k++) {
                if (memberAlreadyInGroup[k].id_user_account === json.groups[i].members[j].id_user_account) {
                  that.$f7.alert(that.$t('errors.selected_two_times', {hintselection: json.groups[i].members[j].identifier}), that.$t('errors.member_duplication_error'), function () {
                    that.$f7.closeModal()
                  })
                  oneMemberInMultipleGroup = true
                  break
                } else {
                  temp.push(json.groups[i].members[j])
                }
              }
              if (oneMemberInMultipleGroup) {
                break
              }
            }
            memberAlreadyInGroup = memberAlreadyInGroup.concat(temp)
          }
        }
      }
      return (!isTeamNameEmpty && !noGroupError && !oneGroupIsEmpty && !oneGroupLevelZero && !oneMemberInMultipleGroup && !notificationError)
    },
    editTeam () {
      let that = this

      if (this.isEmailContact === 'NO') {
        that.emailNotification = ''
        that.amountNotification = '0'
      }

      var jsonTest = {
        id_business: that.$engine.firstOn().user.get().id,
        name: that.labelTeam,
        email_notification: that.emailNotification,
        amount_notification: that.amountNotification,
        groups: that.groups
      }

      if (this.checkTeamValues(jsonTest)) {
        // Sort groups and members into modification categories
        var sortGroups = {
          add: [],
          modify: [],
          delete: [],
          nothing: []
        }
        var sortMembers = {
          add: [],
          modify: [],
          delete: []
        }

        // Sort new json entries into ADD, MODIFY, NOTHING
        var jsonGroup = ''
        var jsonMembers = ''
        var jsonMember = ''
        var nowMembers = ''
        this.groups.forEach(group => {
          jsonGroup = this.jsonStart.groups.filter(grp => { return grp.id_group === group.id_group })
          if (jsonGroup.length === 0) {
            sortGroups.add.push(group)
          } else {
            if (jsonGroup[0].level !== group.level || jsonGroup[0].label !== group.label) {
              sortGroups.modify.push(group)
            } else {
              sortGroups.nothing.push(group)
            }
            // Sort members into ADD, MODIFY
            jsonMembers = jsonGroup[0].members
            nowMembers = group.members

            nowMembers.forEach(member => {
              member.id_group = group.id_group
              jsonMember = jsonMembers.filter(mbr => { return mbr.id_user_account === member.id_user_account })
              if (jsonMember.length === 0) {
                sortMembers.add.push(member)
              } else if (jsonMember[0].visibility !== member.visibility) {
                sortMembers.modify.push(member)
              }
            })

            var memberIds = nowMembers.filter(mbr => { return (typeof mbr.id_user_account) !== 'undefined' }).map(mbr => { return mbr.id_user_account })
            // Sort members into DELETE
            jsonMembers.forEach(member => {
              member.id_group = group.id_group
              if (!memberIds.includes(member.id_user_account)) {
                sortMembers.delete.push(member)
              }
            })
          }
        })

        // Sort deleted entries from jsonStart into DELETE
        var groupIds = this.groups.filter(grp => { return (typeof grp.id_group) !== 'undefined' }).map(grp => { return grp.id_group })
        this.jsonStart.groups.forEach(group => {
          if (!groupIds.includes(group.id_group)) {
            sortGroups.delete.push(group)
          }
        })

        // Create team update JSON
        var team = {
          id_team: that.jsonStart.id_team,
          name: that.labelTeam,
          email_notification: that.emailNotification,
          amount_notification: that.amountNotification,
          groups: sortGroups,
          members: sortMembers
        }

        // Send update request
        this.$engine.firstOn().accounts.updateGroup(team)
        .then(() => {
          that.$f7.alert(that.$t('success.team_updated'), that.$t('success.success_label'), function () {
            that.$f7.closeModal()
            that.$bus.$emit('refresh-cache-account-members')
            loadPage(that, {url: '/accountMembers/'})
          })
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
      }
    }
  }
}
</script>
<style scoped>

.mobile-card-body {
  padding-top: 10px;
  text-align: left;
}

.page-title {
  margin-top: 40px;
  margin-bottom: 30px;
  margin-left: 10px;
}

.headerGroupList {
  text-align: center;
  margin-right: 0;
}

.actionGroupDiv {
  padding-left: 30px;
  padding-top: 10px;
  padding-right: 30px;
  text-align: left;
}

.groupDiv {
  text-align: center;
  margin-bottom: 16px;
  font-size: 12px;
  margin-right: 0;
}
.leftGroupDiv {
  background: #fff;
  text-align: left;
  font-size: 15px;
  padding-right: 0;
  padding-left: 5px;
}
.rightGroupDiv {
  background: #fff;
  text-align: left;
  font-size: 15px;
  min-height: 110px;
  padding-top: 10px;
  border-width: 2px;
  border-style: hidden solid hidden solid;
  border-color: #ddd;
}

.groupDivContainers {
  padding: 0;
  margin: 0;
  border-width: 2px;
  border-style: solid solid solid solid;
  border-color: #ddd;
}

.label-group {
  margin-left: 5px;
  text-align: left;
}

.button-add-group {
  width: 100%;
  text-align: center;
  color: #000;
  border-color: #000;
  background-color: #fff;
  border-radius: 10px;
  border-style: solid;
  border-width: 1px;
  height: 50px;
  margin-right: 15px;
}
.button i.icon:first-child {
  margin-right: 0;
}

.button-delete {
  color: #000;
  background-color: white;
  border-style: 1px solid;;
  border-color: #000;
}
.button-delete-group {
  margin-top: 0;
  margin-bottom: 10px;
  height: auto;
  word-wrap: inherit;
  font-size: inherit;
}

.btn-mobile-footer {
  margin: 5px;
}

.icon-delete-member {
  color: #e53f4e;
  font-size: 20px;
}

.arrow-box {
  margin-top: 1%;
  padding-left: 5%;
}

.icon-arrow-sort {
  color: #000;
  font-size: 40px;
  padding-left: 0;
}

.icon-arrow-sort-up {
}

.icon-arrow-sort-down {
  margin-bottom: 0;
}

.icon-arrow-disabled {
  color: #BDBDBD;
  cursor: not-allowed;
}

.lvl-group {
  margin-bottom: 0;
  margin-right: 0;
  padding-left: 8px;
}

.card-header {
  align-items: end;
}
.card {
  margin-left: auto;
  margin-right: auto;
}
.emailsize {
  font-size: smaller
}
input {
  text-align: center;
}
@media (max-width: 768px) {
  .height-button {
    margin-top: -20px;
  }
}
.button-add-mbr {
  background-color: black !important;
  color: white !important;
}
</style>
